<template>
  <div class="my-schedule">
    <div class="schedule-type active0 my-schedule-type">
      <div
        class="schedule-type__button active"
        v-on:click="setActiveEventType(0)"
      >
        Predavanja i paneli
      </div>
      <div class="schedule-type__button" v-on:click="setActiveEventType(1)" v-if="features.workshops">
        Radionice
      </div>
    </div>
    <section class="schedule-container">
      <section class="schedule-item-container my-schedule-item-container">
        <template v-if="lectureEvents.length !== 0">
          <div class="event-title" v-if="getEventsOnDayByDayAndEventArray(0, lectureEvents).length !== 0">
            1. petak
          </div>
          <template v-for="event in getEventsOnDayByDayAndEventArray(0, lectureEvents)">
            <ScheduleItem
              v-bind:event="event"
              v-bind:key="event.id"
              v-bind:appliedEvents="appliedEvents"
              v-bind:favoritedEvents="favoritedEvents"
            />
          </template>
          <div class="event-title" v-if="getEventsOnDayByDayAndEventArray(1, lectureEvents).length !== 0">
            2. subota
          </div>
          <template v-for="event in getEventsOnDayByDayAndEventArray(1, lectureEvents)">
            <ScheduleItem
              v-bind:event="event"
              v-bind:key="event.id"
              v-bind:appliedEvents="appliedEvents"
              v-bind:favoritedEvents="favoritedEvents"
            />
          </template>
        </template>
        <div v-else class="no-data">Nemaš spremljenih predavanja.</div>
      </section>
      <section class="schedule-item-container my-schedule-item-container">
        <template v-if="appliedEvents && appliedEvents.length !== 0">
          <div class="event-title" v-if="getEventsOnDayByDayAndEventArray(0, appliedEvents).length !== 0">
            1. petak
          </div>
          <template v-for="event in getEventsOnDayByDayAndEventArray(0, appliedEvents)">
            <ScheduleItem
              v-bind:event="event"
              v-bind:key="event.id"
              v-bind:appliedEvents="appliedEvents"
              v-bind:favoritedEvents="favoritedEvents"
            />
          </template>
          <div class="event-title" v-if="getEventsOnDayByDayAndEventArray(1, appliedEvents).length !== 0">
            2. subota
          </div>
          <template v-for="event in getEventsOnDayByDayAndEventArray(1, appliedEvents)">
            <ScheduleItem
              v-bind:event="event"
              v-bind:key="event.id"
              v-bind:appliedEvents="appliedEvents"
              v-bind:favoritedEvents="favoritedEvents"
            />
          </template>
        </template>
        <div v-else class="no-data">Nemaš spremljenih radionica.</div>
      </section>
      <section class="schedule-item-container my-schedule-item-container">
        <template v-if="jigsawEvents.length !== 0">
          <div class="event-title" v-if="getEventsOnDayByDayAndEventArray(0, jigsawEvents).length !== 0">
            1. petak
          </div>
          <template v-for="event in getEventsOnDayByDayAndEventArray(0, jigsawEvents)">
            <ScheduleItem
              v-bind:event="event"
              v-bind:key="event.id"
              v-bind:appliedEvents="appliedEvents"
              v-bind:favoritedEvents="favoritedEvents"
            />
          </template>
          <div class="event-title" v-if="getEventsOnDayByDayAndEventArray(1, jigsawEvents).length !== 0">
            2. subota
          </div>
          <template v-for="event in getEventsOnDayByDayAndEventArray(1, jigsawEvents)">
            <ScheduleItem
              v-bind:refreshFavorites="onRefresh"
              v-bind:event="event"
              v-bind:key="event.id"
              v-bind:appliedEvents="appliedEvents"
              v-bind:favoritedEvents="favoritedEvents"
            />
          </template>
        </template>
        <div v-else class="no-data">Nemaš spremljenih jigsaw sessiona.</div>
      </section>
    </section>
  </div>
</template>

<script>
import ScheduleItem from '@/components/app/ScheduleItem.vue';
export default {
  name: 'MySchedule',
  data() {
    return {
      route: 'app/schedule',
      features: {},
    };
  },
  components: {
    ScheduleItem,
  },
  props: {
    appliedEvents: Array,
    favoritedEvents: Array,
    distinctDays: Array,
    activeEventType: Number,
    changeActiveEventTypeOnSchedule: Function,
    refreshFavorites: Function,
  },
  computed: {
    lectureEvents: function() {
      return this.favoritedEvents.filter(e => e.type === 'Lecture');
    },
    jigsawEvents: function() {
      return this.favoritedEvents.filter(e => e.type === 'JigsawSession');
    },
  },
  methods: {
    getEventsOnDayByDayAndEventArray: function(day, eventArray) {
      const result = eventArray
        .filter(event => new Date(event.starts).getDate() === this.distinctDays[day])
        .sort((firstEvent, secondEvent) => (new Date(firstEvent.starts) < new Date(secondEvent.starts) ? -1 : 1));

      return result;
    },
    setActiveEventType: function(indexOfContainerToShow) {
      this.changeActiveEventTypeOnSchedule(indexOfContainerToShow);
      let scheduleItemContainers = document.querySelectorAll('.my-schedule-item-container');
      let scheduleTypeButtons = document.querySelectorAll('.my-schedule-type__button');
      let scheduleType = document.querySelector('.my-schedule-type');
      for (let i = 0; i < 3; i++) {
        if (i === indexOfContainerToShow) scheduleType.classList.add(`active${i}`);
        else scheduleType.classList.remove(`active${i}`);
      }
      scheduleTypeButtons.forEach((button, index) => {
        button.classList.remove('active');
        if (index === indexOfContainerToShow) button.classList.add('active');
      });
      for (let container of scheduleItemContainers) container.classList.remove('active');
      scheduleItemContainers[indexOfContainerToShow].classList.add('active');
      document.dispatchEvent(new CustomEvent('scroll'));
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/features/route`, { params: { route: this.route } }).then(response => {
      this.features = response.data.features.reduce((acc, x) => {
        acc[x.path.replace(`${this.route}/`, '')] = x.isActive;

        return acc;
      }, {});
    });
  },
  mounted() {
    this.setActiveEventType(this.activeEventType);
  },
};
</script>

<style>
.my-schedule-type {
  padding: 0;
}

.event-title {
  font-size: 24px;
}

.event-title::after {
  transform: translateX(0);
}

.no-data {
  width: 100%;
  text-align: center;
  margin-top: 110px;
  margin-bottom: 30px;
  color: #7a8e94;
  font-weight: bold;
  font-size: 24px;
}
</style>
